import { useEffect, useRef } from "react";

export type Props = {
  id: string;
  rel: string;
  href: string;
  isDisabled?: boolean;
};

export default function useLink({ id, rel, href, isDisabled = false }: Props) {
  const createdByHookRef = useRef(false);

  useEffect(() => {
    const removeIfOwned = () => {
      if (createdByHookRef.current) {
        document.getElementById(id)?.remove();
        createdByHookRef.current = false;
      }
    };

    if (isDisabled) {
      removeIfOwned();

      return;
    }

    if (document.getElementById(id)) {
      return;
    }
    const link = document.createElement("link");

    link.id = id;
    link.rel = rel;
    link.href = href;

    document.head.appendChild(link);
    createdByHookRef.current = true;

    return removeIfOwned;
  }, [id, rel, href, isDisabled]);
}
